import { normalizeLocale, type SupportedLocale } from '@/i18n/config';

const OPENING_GREETING_BY_LOCALE = {
  en: 'Hi. What would you like to work on?',
  'pt-BR': 'Ol\u00E1. No que gostaria de trabalhar?',
  ar: 'مرحبًا. ما الذي سنعمل عليه؟',
  es: 'Hola. ¿En qué te gustaría trabajar?',
  fr: 'Bonjour. Sur quoi aimeriez-vous travailler ?',
  it: 'Ciao. Su cosa vorresti lavorare?',
  ko: '안녕하세요. 무엇을 해볼까요?',
  de: 'Hallo. Woran möchtest du arbeiten?',
  ja: 'こんにちは。何に取り組みたいですか？',
  hi: 'नमस्ते। हम किस पर काम करें?',
  ru: 'Привет. Над чем вы хотели бы поработать?',
  zh: '你好。你想做些什么？',
  'zh-TW': '你好。你想做些什麼？',
  vi: 'Xin chào. Bạn muốn làm gì?',
  id: 'Hai. Kamu ingin mengerjakan apa?',
} satisfies Record<SupportedLocale, string>;

export function getRealtimeVoiceOpeningGreetingInstruction(
  locale: string | null | undefined
): string {
  const greeting = OPENING_GREETING_BY_LOCALE[normalizeLocale(locale)];
  return `For the opening greeting, say exactly: "${greeting}" If voice.md names the user, add their first name to the first greeting word, as a natural speaker of this language would. Do not add any other words.`;
}
